module.exports = __webpack_public_path__ + "img/facades-icon.62d20883.svg";